import { createApp } from 'vue'
import App from './JoinPractice.vue'

createApp(App).mount('#app-join-practice')
